import React, { useState, useEffect } from "react" 
import { getUserID, getUserName, getUserEntityIsEmployee } from "../datainfo/dto";
import { fetchData } from "../../hooks/fetch/const_fetch"; 
import {URL, SAVEUPDATEREFERENCE, CLOSEREFERENCE, GETREFERENCEBYID,URL_CONSULTAR_SUCURSALES,URL_LOGIN_SUCURSALES,USER,PSW} from "../paths";
import "./MostrarPdf.css"
import { getUserBillingIdentifier, getUserFiscalIdentifier } from "../datainfo/dto";
import { useModal } from "../../hooks/useModal";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Loader from "../loader/loader"; 
import Modal from "../modal";
const MostrarPdf = ({referenciaid, estatus, setEstatus, pbip, solicitado_por, muellaje, buque ,pdfData,preview, strreferencia="no hay valor", intmode, strDocumentTypeDescription, Mensaje,ConsultarDocumentosUsuario, mimetype, isOpenMostrarPdf, OpenMostrarPdf, closeMostrarPdf,OpenRechazarPdf })=>{
    
    const [isOpenCerrarProceso, OpenCerrarProceso, closeCerrarProceso] = useModal(false);
    
    const [tabIndex, setTabIndex] = useState(0);
    const [documentos,setDocumentos] = useState([]);
    const [primera,setPrimera] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [intCusDocReleasedId,setIntCusDocReleasedId] =  useState("1083197");
    const [validaReleasedId,setValidaReleasedId] =  useState("");

    const handleRechazar = () => { 
        OpenRechazarPdf(); 
    }
 
    const [peticion_fallida,setPeticionFallida] = useState(false);

    const [intInvDockTypeId,setIntInvDockTypeId] = useState(0); //id de tipo de entidad fact-muellaje
    const [intInvDockId,setIntInvDockId] = useState(0); // id de entidad fact- muellaje
    const [intInvDockAddressId,setIntInvDockAddressId] = useState(0); // id de sucursal fact- muellaje
    const [strInvDockFiscalId,setStrInvDockFiscalId] = useState(""); //RFC entidad fact- muellaje
    const [strInvDockZipCode,setStrInvDockZipCode] = useState(""); //CP de sucursal entidad fact- muellaje,
    const [strDockAddress,setStrDockAddress]=useState("");

    const [intInvPBIPTypeId,setIntInvPBIPTypeId] = useState(0); //id de tipo de entidad fact- PBIP
    const [intInvPBIPId,setIntInvPBIPId] = useState(0); //id de entidad fact:- PBIP
    const [intInvPBIPAddressId,setIntInvPBIPAddressId] = useState(0); // id direccion muellaje
    const [strInvPBIPFiscalId,setStrInvPBIPFiscalId] = useState(""); //RFC entidad fact- PBIP
    const [strInvPBIPZipCode, setStrInvPBIPZipCode] = useState(""); //CP de sucursal entidad fact- PBIP
    const [strPBIPAddress,setStrPBIPAddress]=useState("");

    const [strtok,setStrTok] = useState("");
    const LOG_TOKEN = async( mostrar_cortinilla=true)=>{
        try{
            if(mostrar_cortinilla){
                setIsLoading(true); 
            } 
                const url = URL_LOGIN_SUCURSALES; 
                const params =  {
                    "userName" : USER,
                    "password" : PSW
                }           
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                
                const resultado =  await fetchData(url, 'POST' , myHeaders, params); 
                if(resultado.token !== "" && resultado.token !== undefined){ 
                    setStrTok( resultado.token ); 
                    ConsultarDocumentos(resultado.token);
                }else{
                    setStrTok("");
                    setPeticionFallida(true); 
                    if(resultado.code < 0){
                        Mensaje(resultado.msg, "info", "bottom-right", 4500);
                    }
                    if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                      //
                      if(resultado.status === 404){
                        Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                      }else if(resultado === "Failed to fetch"){
                        Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                      }
                    }  
                    setIsLoading(false);    
                } 
        }catch (error) {
            setIsLoading(false); 
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    }
 
    const handleKeyPress = (e) => {
        // Si el carácter no es un número, se previene la acción
        if(!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
        if ( !(e.target.value.length <= 9) ) {
            e.preventDefault();
        }
      };
    
    const handleChange = (e) => {
        setIntCusDocReleasedId(e.target.value);
    };

    const handleValidar = async()=>{
        try {  
            setIsLoading(true);  
            if(referenciaid <= 0){
                setIsLoading(false); 
                return;
            }else{
                const dto = {   
                    "intMode":4, 
                    "strUserName":getUserName(),
                    "ref":{
                        "intCusDocId": referenciaid,
                    }
                } 
                const url = URL+SAVEUPDATEREFERENCE; 
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
             
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
                
                if(resultado.code === 0){ 
                    Mensaje(resultado.msg, "success", "top-center", 5000); 
                    setEstatus(resultado.ref.strStatus);
                }else{
                    if(resultado.code < 0){
                        Mensaje(resultado.msg,"error","top-center",4500);    
                    }
                    else if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                        if(resultado.status === 404){
                            Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                        }else if(resultado === "Failed to fetch"){
                            Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                        }
                    } 
                    setIsLoading(false);
                }
                setIsLoading(false); 
                ConsultarDocumentosUsuario(); 
            }  
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud - GuardarDocumento(), ERROR: "+error.message ,"error","top-center");
        }
    } 
    
    const ConsultarSucursales = async(clientId, rfcClient, agentId, rfcAgent, _strtok, intInvPBIPAddressId, code, mostrar_cortinilla=true )=>{ 
        try{ 
            setIsLoading(true);
            ///setValidaEntidad("");
            const url = URL_CONSULTAR_SUCURSALES; 
            const params =  {
                "clientId" : clientId, //intBillId,//entidadid,
                "rfcClient" : rfcClient,//regfc, 
                "agentId" : agentId,//getUserBillingIdentifier(),
                "rfcAgent" : rfcAgent//getUserFiscalIdentifier(),
            }     
            const myHeaders = new Headers();
            if(_strtok !== ""){
                myHeaders.append("Content-Type", 'application/json');  
                myHeaders.append("Authorization", ('Bearer '+_strtok) );
              }  
            const resultado =  await fetchData(url, 'POST',myHeaders,params);   
            if(resultado.result){  
                    if(resultado.address !== null){ 
                        if(resultado.address.length === 1 ){ 
                            let index = -1;
                            if(code === 1){
                                index = resultado.address.findIndex(item =>  (item.customerAddressId === intInvPBIPAddressId));
                                if(index >= 0){ 
                                    setStrPBIPAddress("CP: "+resultado.address[index].postalCode+" "+resultado.address[index].countryDesc+ ", "+resultado.address[index].estadoDesc);
                                }else{
                                    setStrPBIPAddress(" no hay sucursal asignada");
                                }
                               
                            }else{
                                index = resultado.address.findIndex(item =>  (item.customerAddressId === intInvPBIPAddressId));
                                if(index >= 0){
                                    setStrDockAddress("CP: "+resultado.address[index].postalCode+" "+resultado.address[index].countryDesc+ ", "+resultado.address[index].estadoDesc);
                                }else{
                                    setStrDockAddress(" no hay sucursal asignada");
                                }
                            }   

                             
                        }else{
                            if(code === 1){ 
                                setStrPBIPAddress(" no hay sucursal asignada");
                            }else{
                                setStrDockAddress(" no hay sucursal asignada");     
                            }   
                        }
                    }else{
                        Mensaje(resultado.comment,"error","top-center",4500);
                        if(code === 1){ 
                            setStrPBIPAddress(" no hay sucursal asignada");
                        }else{
                            setStrDockAddress(" no hay sucursal asignada");     
                        }   
                    }
                
                setIsLoading(false); 
            }else{
                if(code < 0){
                    Mensaje(resultado.comment, "error","top-center",4000);
                    setPeticionFallida(true); 
                }
                if(resultado === "signal is aborted without reason"){
                    Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                }else{
                  //
                  if(resultado.status === 404){
                    Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                  }else if(resultado === "Failed to fetch"){
                    Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                  }
                }  
            }
            setIsLoading(false);   
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    } 

    const ConsultarDocumentos = async(strtok)=>{
        try { 
            setIsLoading(true); 
            
            if(referenciaid <= 0){
                setIsLoading(false); 
                return;
            }else if(strtok === ""){
                Mensaje("No se ha podido obtener acceso a las sucursales.","warning","top-center",5000);
                CerrarProceso();
                setIsLoading(false); 
                return;
            }else{
                const dto = {   
                    "intUserId":getUserID(),
                    "intCusDocId": referenciaid,
                }  
                const url = URL+GETREFERENCEBYID; 
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
                if(resultado.code === 0){ 
                    setIsLoading(false);
                    if(resultado.docs.length > 0){ 
                        setDocumentos(resultado.docs); 
                        
                        setIntInvDockTypeId(resultado.ref.intInvDockTypeId); //id de tipo de entidad fact-muellaje
                        setIntInvDockId(resultado.ref.intInvDockId); // id de entidad fact- muellaje
                        setIntInvDockAddressId(resultado.ref.intInvDockAddressId); // id de sucursal fact- muellaje
                        setStrInvDockFiscalId(resultado.ref.strInvDockFiscalId); //RFC entidad fact- muellaje
                        setStrInvDockZipCode(resultado.ref.strInvDockZipCode); //CP de sucursal entidad fact- muellaje,
                        
                        setIntInvPBIPTypeId(resultado.ref.intInvPBIPTypeId); //id de tipo de entidad fact- PBIP
                        setIntInvPBIPId(resultado.ref.intInvPBIPId); //id de entidad fact:- PBIP
                        setIntInvPBIPAddressId(resultado.ref.intInvPBIPAddressId); // id direccion muellaje
                        setStrInvPBIPFiscalId(resultado.ref.strInvPBIPFiscalId); //RFC entidad fact- PBIP
                        setStrInvPBIPZipCode(resultado.ref.strInvPBIPZipCode); //CP de sucursal entidad fact- PBIP


                        ConsultarSucursales(  parseInt(resultado.ref.strInvPBIPBillId), resultado.ref.strInvPBIPRFC.trim() , parseInt(resultado.ref.strCusDocEntityBillId) , resultado.ref.strCusDocEntityRFC,strtok, parseInt(resultado.ref.intInvPBIPAddressId) ,1); 
                        ConsultarSucursales(  parseInt(resultado.ref.strInvDockBillId), resultado.ref.strInvDockRFC.trim() , parseInt(resultado.ref.strCusDocEntityBillId) , resultado.ref.strCusDocEntityRFC,strtok, parseInt(resultado.ref.intInvDockAddressId) ,2); 

                    }else{
                        setDocumentos([]); 
                        setIntInvDockTypeId(0); //id de tipo de entidad fact-muellaje
                        setIntInvDockId(0); // id de entidad fact- muellaje
                        setIntInvDockAddressId(0); // id de sucursal fact- muellaje
                        setStrInvDockFiscalId(""); //RFC entidad fact- muellaje
                        setStrInvDockZipCode(""); //CP de sucursal entidad fact- muellaje,
                        
                        setIntInvPBIPTypeId(0); //id de tipo de entidad fact- PBIP
                        setIntInvPBIPId(0); //id de entidad fact:- PBIP
                        setIntInvPBIPAddressId(0); // id direccion muellaje
                        setStrInvPBIPFiscalId(""); //RFC entidad fact- PBIP
                        setStrInvPBIPZipCode(""); //CP de sucursal entidad fact- PBIP
                        Mensaje(resultado.msg, "warning", "top-center", 5000);
                    }  
                }else{
                    if(resultado.code < 0){
                        Mensaje(resultado.msg,"error","top-center",5000);
                        setIsLoading(false); 
                    }
                    if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                      //
                      if(resultado.status === 404){
                        Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                      }else if(resultado === "Failed to fetch"){
                        Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                      }
                    } 
                    setIsLoading(false);
                  } 
            } 
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud - GuardarDocumento(), ERROR: "+error.message ,"error","top-center");
        }
    } 
    const HandleCerrarProceso = async() => {
        try{
            if( parseInt(intCusDocReleasedId) < 0  || intCusDocReleasedId === "" || intCusDocReleasedId.length > 10){
                setValidaReleasedId(" is-invalid ")
                return;
            }else{
                setValidaReleasedId(" is-valid ")
            }

            setIsLoading(true); 
                if(referenciaid <= 0 || referenciaid === undefined){
                    Mensaje("No se ha asignado una referencia valida.", "error", "bottom-right", 4500);
                    return;
                }
                const url = URL+CLOSEREFERENCE; 
                const params = {
                    "intUserId": parseInt(getUserID()),
                    "intCusDocId":parseInt(referenciaid),
                    "intCusDocReleaseId":parseInt(intCusDocReleasedId)
                } 
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
                if(resultado.code === 0 ){//&& resultado.rows[0].code === 0){   
                    Mensaje(resultado.msg, "success", "bottom-right", 4500);
                    closeMostrarPdf();
                    ConsultarDocumentosUsuario()
                }else{
                    if(resultado.code < 0){
                        Mensaje(resultado.msg, "info", "bottom-right", 4500);
                        setPeticionFallida(true); 
                    }
                    if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                      //
                      if(resultado.status === 404){
                        Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                      }else if(resultado === "Failed to fetch"){
                        Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                      }
                    }  
                } 
                setIsLoading(false);
        }catch(err){

        }
    }
    const CerrarProceso = async(referenciaid) => {
        try {  
            OpenCerrarProceso(true);
            setIntCusDocReleasedId(""); 
        }catch (error) {
            Mensaje("Se ha presentado un error, ERROR: "+error.message ,"error","bottom-right",4500);
        }
    }
    /*************************************************************************** */
    const downloadPdf = (base64String, fileName) => {
        // Decodificar el string base64
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear un elemento de enlace
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const Descargar_PDFs = () =>{
        try { 
            for (let index = 0; index < documentos.length; index++) {
                const element = documentos[index]; 
                downloadPdf(element.imgDocumentImageFile, element.strDocumentFolio+"-"+element.strDocumentTypeDescription)
            }
        } catch (error) {
            alert(error)
        }
        
    }

    // Ejemplo de uso
    const base64String = "..." // tu cadena Base64 aquí
    const filename = "archivo.pdf"; // nombre de archivo deseado
    const mimeType = "application/pdf"; // tipo MIME del archivo
 
    /*************************************************************************** */

    useEffect(()=>{
        if(intmode !== 777){
            LOG_TOKEN();
        }
        
    },[]);


    if(peticion_fallida){
        CerrarProceso();
    }

    return( 
        <>  
            {isLoading?<Loader />:<></>} 
            {preview !== 200?

            <div className="container-fluid">
                <div className="modal-body p-0 m-0">{/* style={{height:'100px',overflow:"scroll"}} > */}
                
                        {parseInt(getUserEntityIsEmployee()) === 1 && intmode===0 ?//&& documentos.length > 0 ? 
                            <div className="row py-0">
                                {intmode === 0 && estatus === "CAP" && documentos.length > 0  ?
                                    <div className="col-4">
                                        <button className="btn btn-primary col-12 p-0" onClick={handleValidar}>COMENZAR VALIDACIÓN</button>
                                    </div>:<></>
                                }    
                                {intmode === 0 && estatus === "ON-VALID" ||  estatus === "CAP"?//"SENT" ?
                                    <div className="col-4">
                                        <button className="btn btn-danger col-12  p-0" onClick={handleRechazar}>RECHAZAR</button>
                                    </div>:<></>
                                }     
                                {intmode === 0 && estatus === "ON-VALID"?//"SENT" ?
                                    <div className="col-4">   
                                        <button className="btn text-bg-success col-12  p-0" onClick={ ()=>{CerrarProceso(referenciaid)} }  > <span className="fw-normal">CERRAR PROCESO</span> </button>
                                    </div>:<></>
                                }
                                
                            </div>:<></>
                        }
                        
                        <div className="pdfcontainer">
                            <div className="row">
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="fs-6">SOLICITADO POR:</label>
                                    <label className="form-control  form-control-sm">{solicitado_por}</label>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    
                                <label className="fs-6">FACTURAR PBIP A:</label>
                                {strPBIPAddress !== "" ?
                                    <label className="form-control  form-control-sm">{`${pbip} - ${strPBIPAddress}`}</label>
                                    :<label className="form-control  form-control-sm"></label>
                                }
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="fs-6">FACTURAR MUELLAJE A:</label>
                                {strDockAddress !== "" ?
                                    <label className="form-control  form-control-sm">{`${muellaje} - ${strDockAddress}`}</label>
                                    :<label className="form-control  form-control-sm"></label>
                                }
                                 
                                </div>
                            
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="fs-6">BUQUE:</label>
                                    <label className="form-control  form-control-sm">{buque}</label>
                                </div> 
                        </div>
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"> 
                                    <button className="btn text-bg-primary w-100 fs-bold my-3" onClick={Descargar_PDFs}>DESCARGAR ARCHIVOS PDF</button>
                                </div> 
                            </div>
                        </div>   
                </div>
                <div className="pdfcontainer">
                    {documentos.length > 0 ?
                        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                            <TabList>
                            {
                                documentos.map((item, index)=>(
                                    <Tab key={item.intDocumentId+"-"+index}> 
                                             <span  key={item.strDocumentFolio} className={"fw-bold "} >{item.strDocumentFolio}</span>
                                    </Tab>
                                ))
                            }
                            </TabList>
                                {
                                    documentos.map((item,index)=>(
                                        <TabPanel key={"Panel"+item.intDocumentId+"-"+index}> 
                                            {   
                                                <>
                                                    <div className="row my-1 ">
                                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                            <label className="fs-6">FOLIO:</label>
                                                            <label className="form-control  form-control-sm">{item.strDocumentFolio}</label>
                                                        </div>
                                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                            <label className="fs-6">TIPO DE DOCUMENTO:</label>
                                                            <label className="form-control  form-control-sm">{item.strDocumentTypeDescription}</label>
                                                        </div> 
                                                    </div>
                                                    <div className="row "> 
                                                        <embed
                                                            name={"archivo"} 
                                                            src={`data:${mimetype};base64,${item.imgDocumentImageFile}`}
                                                            type={mimetype}
                                                            width={'100%'} 
                                                        />
                                                    </div>
                                                </>
                                                }
                                        </TabPanel>    
                                    ))
                                } 
                        </Tabs>:
                        <div className="alert alert-danger m-2 py-4"> <span className="fs-4 fw-bold">Referencia existente pero sin documentos.</span></div>
                    }   
                </div>   
            </div> 
            :<div className="modal-body py-0" > 
                {pdfData!==""?
                <div className="row p-0">
                        <embed src={`data:${mimetype};base64,${pdfData}`}
                            type={mimetype}
                            width={'100%'}
                            Height={'20vh'}
                        />
                    </div>
                :<div className="alert alert-danger py-4">NO HAY ARCHIVO PDF SELECCIONADO.</div>                        
                }
            </div>
            }
            <div className="modal-footer">
                <div className="row ">
                    <div> 
                        <button className="btn bg-secondary text-white fw-bold float-end mx-1" onClick={closeMostrarPdf}>CERRAR</button>
                    </div>
                </div>    
            </div>  
            { isOpenCerrarProceso &&
                    <div id="modal-cerrar-validacion">
                        <Modal titulo={"CERRAR VALIDACION DE REFERENCIA"} isOpen={isOpenCerrarProceso} closeModal={closeCerrarProceso} Width={'50vw'}   >
                                        <div className="p-3">
                                            <p className="h5 my-2">PARA CERRAR EL PROCESO DEBE ASIGNAR UN ID DE CALATHUS.</p>
                                            <div className="row  my-2">
                                                <div className="col-3">
                                                    <p className="h5">ID DE LIBERACIÓN CALATHUS:</p>
                                                </div>
                                                <div className="col-7">
                                                <input  
                                                    type="text" 
                                                    value={intCusDocReleasedId} 
                                                    onChange={handleChange} 
                                                    onKeyPress={handleKeyPress} 
                                                    className={`form-control ${validaReleasedId}`} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer ">
                                            <div className="row ">
                                                <div> 
                                                    <button className="btn bg-success text-white fw-bold float-end mx-1" onClick={HandleCerrarProceso}>CERRAR PROCESO</button>
                                                    <button className="btn bg-secondary text-white fw-bold float-end mx-1" onClick={closeCerrarProceso}>CERRAR</button>
                                                </div>
                                            </div>    
                                        </div>
                        </Modal>
                    </div>
                } 
        </>
    )


    //ModalConfirmacion=(txtbtnconfirmar, evtconfirmar, mensaje,closeModalConfirmacion)
} 

export default MostrarPdf;